import { HtmlComponent } from './../html-component';

// import html
import template from './text-component.hogan.html';

// js

export class TextComponent extends HtmlComponent {
    constructor(parameters: {}) {
        super(template, parameters);
    }

    public enable() {
        this.jqueryElement.addClass('text-component-enabled');
        this.jqueryElement.removeClass('text-component-disabled');
    }

    public disable() {
        this.jqueryElement.removeClass('text-component-enabled');
        this.jqueryElement.addClass('text-component-disabled');
    }

    public hide() {
        this.jqueryElement.hide();
    }

    public show() {
        this.jqueryElement.show();
    }

    public setText(text: string) {
        this.jqueryElement.html(text);
    }
}
